const initialState = {
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      page: 1,
      size: 10,
      created_at__lt: '',
    },
    data: {
      items: [],
      count: 0,
      unreadCount: 0,
    },
  },
};

export default initialState;
